import { Modal } from '@tryhackme/thm-ui-components';
import { SignupForm } from 'src/features/signup/components/signup-form/signup-form';
import { SignupModalProps } from './signup-modal.types';
export const SignupModal: React.FC<SignupModalProps> = ({
  open,
  initialEmail,
  onOpenChange
}) => <Modal open={open} onOpenChange={onOpenChange} isSmall maxHeight="100%" padding="2.6rem 3rem 3rem" preventOnOpenAutoFocus data-sentry-element="Modal" data-sentry-component="SignupModal" data-sentry-source-file="signup-modal.tsx">
    <SignupForm initialEmail={initialEmail} onOpenChange={onOpenChange} data-sentry-element="SignupForm" data-sentry-source-file="signup-modal.tsx" />
  </Modal>;